export default __webpack_public_path__ + "static/desklocation02-25fe6141d8236433917d1e8b29f2fbe6.png";